import React, {useState, useEffect, useRef, useMemo} from 'react';
import { history} from '../../utils/variables';
import {pexios, uploadImages, hardCopy, getQueryString, UserLabel, toast} from '../../utils/functions';
import {useDispatch, useSelector} from 'react-redux';
import {setRouterData} from '../../redux/actions';
import UploadDocs from '../../components/pages/complete/UploadDocs';
import UploadCarImage from '../../components/pages/complete/UploadCarImages';
import { useTranslation } from 'react-i18next';
import HeaderIcon from '../../assets/images/header-icon/camera.png'
import Modal from '../../components/master/Modal';
import ImageZoom from '../../components/master/ImageZoom';
import Timer from '../../components/master/Timer';
import ScreenCamera from '../../components/master/ScreenCamera';

export default function UserImages() {
    const { t } = useTranslation();
    const {routerData , accidentInfo,insuranceCode} = useSelector((store) => store);
    const user_type = accidentInfo.user_type || 'culprit'
    const insurance_type = accidentInfo.insurance_type ;
    const id = routerData?.id;
    const dispatch = useDispatch();
    const lossesIndex = getQueryString('index') || 1
    // const [accident, setAccident] = useState({
    //     attachments: [],
    //     losses: [],
    // });
    const [attachments,setAttachments] = useState([])
    useEffect(()=>{
        id && pexios(`api/get_accident_photos/${id}`)
        .then((res)=>{
            setAttachments(res.data.attachments)
        })
    },[id])
    const labels = useMemo(()=>{
        let images = ['front_image','front_right_image','right_image','back_right_image','back_image','back_left_image','left_image','front_left_image','chassis_number','license_image','license_back_image','vehicle_card_image','vehicle_card_back_image','third_image']
        if(insurance_type === 'body') images.push('body_image')
        if(insuranceCode === 'l9Rx6eo2') images.push('plate_chassis') //bimeBazzar
        if((insuranceCode === 'l9Rx6eo2'&& user_type === 'culprit') || user_type !== 'culprit') images.push('id_card')
            return images
    },[user_type,insuranceCode])
    // const [step, setStep] = useState(null);
    // const [expert, setExpert] = useState({});
    // const [callPermit, setCallPermit] = useState(false);
    // useEffect(() => {
    //     const handlePopState = (event) => {
    //         history.push('/');
    //     };
    //     window.addEventListener('popstate', handlePopState);
    //     return () => {
    //         window.removeEventListener('popstate', handlePopState);
    //     };
    // }, [history]);


    // useEffect(() => {
    //     id && pexios('/api/v2/get_accident', 'post', {accident_id: id , type :'complete'})
    //         .then(res => {
    //             setAccident(res.data.data);
    //             setStep(res.data.data.has_coroukie ? 0 : 1)
    //         });
    // }, [id]);

    // function changeStep(step) {
    //     setStep(step);
    //     const element = document.getElementById(`step${step}`);
    //     setTimeout(() => element.scrollIntoView());
    // }

    // function broadcast(data) {
    //     const content = data.message;
    //     if (parseInt(content.accident_id) === id) {
    //         if (content.message === 'expert_to_accident') {
    //             pexios('/api/v2/get_expert', 'post', {expert_id: content.expert_id})
    //                 .then(res => {
    //                     setExpert(res.data.data);
    //                     setStep(6);
    //                     ///it has to be 7
    //                 });
    //         }
    //         if (content.message === 'expert_arrived') {
    //             dispatch(setRouterData({}));
    //             history.push(`/success/${id}`);
    //         }
    //         if (content.message === 'approve_accident') {
    //             setStep(1);
    //         }
    //     }
    // }

    // function defineStepClass(id) {
    //     let className = 'c-parent';
    //     if (step === id) className = 'c-parent active';
    //     if (step > id) className = 'c-parent done';
    //     return className;
    // }

    function uploadDoc(image, name, done) {
        let copy_attachments = hardCopy(attachments);
        const index = copy_attachments.findIndex(img => img.filename === name);
        uploadImages({
            id,
            type: 'accident',
            name,
            image,
            done,
            callback: (data) => {
                if (index !== -1) copy_attachments[index] = data;
                else copy_attachments.push(data);
                // setAccident(prevState => ({
                //     ...prevState,
                //     attachments,
                // }));
                setAttachments(copy_attachments)
            },
        });
    }

    // function finish(location) {
    //     const data = {
    //         lat: location.lat,
    //         lng: location.lng,
    //         accident_id: id,
    //     };
    //     pexios('api/update_accident_photos', 'post', data)
    //         .then(() => {
    //             if (accident.request_expert === 0) {
    //                 dispatch(setRouterData({}));
    //                 history.push(`/success/${id}`);
    //             } else setStep(6);
    //         });
    // }
    function goToReport() {
        if(insuranceCode === 'l9Rx6eo2'){ //bime bazar
            const error = validate()
            if (error) {
                toast(t('Upload reqired images',{error:error}), 'error');
                return;
            }
        }
        if(insurance_type === 'body') { 
        pexios(`api/finish_culprit_photo/${id}`)
        .then(()=>{
            dispatch(setRouterData({...routerData,id, type: 'accident',state:2 }));
        })
        .then(()=>{
            history.push(`/complete`);
        })
        }else{
            if(user_type === 'culprit') {
                pexios(`api/finish_culprit_photo/${id}`)
                .then(()=>{
                    dispatch(setRouterData({...routerData,id, type: 'accident',state:2 }));
                })
                .then(()=>{
                    history.push(`/losses-info`);
                })  
            }
            else
            history.push(`/losses-info`);

        }
    }
    const imagesLabels = [ 
        {key :t('Front car'),label:'front_image'},
        {key :t('Front Right vehicle'),label:'front_right_image'},
        {key :t('Back car'),label:'back_image'},
        {key :t('Back Right vehicle'),label:'back_right_image'},
        {key :t('Right side car'),label:'right_image'},
        {key :t('Back Left vehicle'),label:'back_left_image'},
        {key :t('Left side car'),label:'left_image'},
        {key :t('Front Left vehicle'),label:'front_left_image'},
        {key :t('Engraved chassis number'),label:'chassis_number'},
        {key :t('Engraved chassis plate'),label:'chassis_plate'},
        {key :t('ID card'),label:'id_card'},
        {key :t('License'),label:'license_image'},
        {key :t('License back'),label:'license_back_image'},
        {key :t('Car card'),label:'vehicle_card_image'},
        {key :t('Car back card'),label:'vehicle_card_back_image'},
        {key :t('Third insurance'),label:'third_image'},
    ]
    function validate() {
        let error = '';
        imagesLabels.forEach(itm => {
            if(user_type === 'culprit'){
                if (attachments.filter(img=> img.filename === `${user_type}_${itm.label}`).length === 0) error = `${error}, ${itm.key}`;
            }
            else
                if (attachments.filter(img=> img.filename === `${user_type}_${itm.label}${lossesIndex}`).length === 0) error = `${error}, ${itm.key}`;
        })
        if(insurance_type === 'body') {
            if (attachments.filter(img=> img.filename === 'culprit_body_image').length === 0) error = `${error}, ${t('Body insurance')}`;
        }
        if(user_type === 'culprit' && accidentInfo.has_coroukie) {
            if (attachments.filter(img=> img.filename.includes('coroukie_image')).length === 0) error = `${error}, ${t('Coroukie image')}`;
        }
        return error
    }
    return (
        <div className='content complete'>
            {(routerData.insuranceCompanyId === 25 || routerData.insuranceCompanyId === 2) ?///bime hafez or iran
            <>
            <ScreenCamera
                imagesLabels={labels}
                finishUpload={goToReport}
                uploadDoc={uploadDoc}
                isRequired={insuranceCode === 'l9Rx6eo2'}
                lossesIndex={lossesIndex}
            />
            </>
            :
            <>
            <div className='title-image'>
                <img src={HeaderIcon} alt="icon"/>
            </div>
            <p className='guide-text mx10 my20'>
                 تصاویر خودرو و مدارک {insurance_type === 'third' && UserLabel(user_type)} را بارگذاری نمایید.
                {/* only required for bime bazzar */}
                {insuranceCode !== 'l9Rx6eo2' && 
                <span>
                 در صورت دردسترس نبودن وسیله نقلیه میتوانید به مرحله بعد بروید.
                بدیهی است تکمیل بودن تصاویر در سرعت روند پیگیری پرونده شما موثر است.
                </span>}
            </p>
            <div className='d-flex flex-row-reverse flex-wrap'>
            {/* <div className='content-parent'>
                <div className='content-box'>                  */}
                    <UploadCarImage
                        // insuranceType={accident.insurance_type}
                        attachments={attachments}
                        // losses={accident.losses}
                        // changeStep={changeStep}
                        uploadDoc={uploadDoc}
                        userType={user_type}
                        lossesIndex={lossesIndex}
                    />                   
                {/* </div>
                    </div>
            <div className='content-parent'>
                <div className='content-box'> */}
                    <UploadDocs
                        attachments={attachments}
                        insuranceType={insurance_type}
                        // losses={accident.losses}
                        // hasCoroukie={accident.has_coroukie}
                        // changeStep={changeStep}
                        uploadDoc={uploadDoc}
                        userType={user_type}
                        lossesIndex={lossesIndex}
                    />                 
                {/* </div>
            </div> */}
            </div>
            <div className='d-flex justify-center'>
                <button className='btn btn-circle btn-block btn-white-purple mt20' onClick={goToReport}>
                    مرحله بعد
                </button>
            </div>
            </>
            }

            {/* <EventBus onEvent={broadcast}/> */}
            {/* <div className='pt50 pb50'>
                <div className='c-parent done'>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-car-crash'/>
                        </div>
                        <div className='title-text'>
                            
                                 { t('Accident notification in the hour')}{ accident && Moment(accident.created_at).format('HH:mm')}
                            
                        </div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'/>
                    </div>
                </div>
                <div className='c-parent done'>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-headset'/>
                        </div>
                        <div className='title-text'>{t('Call and confirm the accident by the headquarters')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'/>
                    </div>
                </div>
                {
                    !!accident.has_coroukie &&
                    <div id='step0' className={defineStepClass(0)}>
                        <div className='title-box'>
                            <div className='icon-box'>
                                <i className='fas fa-paste'/>
                            </div>
                            <div className='title-text'>{step === 0 && t('Waiting')} {t('Send accident image report')}</div>
                        </div>
                        <div className='content-parent'>
                            <div className='content-box'>
                                {
                                    step === 0 &&
                                    <UploadCoroukieImages
                                        attachments={accident.attachments}
                                        changeStep={changeStep}
                                        uploadDoc={uploadDoc}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                }
                <div id='step1' className={defineStepClass(1)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-cloud-upload-alt'/>
                        </div>
                        <div className='title-text'>{step === 1 && t('Waiting')} {t('Send image documents')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 1 &&
                                <UploadDocs
                                    attachments={accident.attachments}
                                    insuranceType={accident.insurance_type}
                                    losses={accident.losses}
                                    hasCoroukie={accident.has_coroukie}
                                    changeStep={changeStep}
                                    uploadDoc={uploadDoc}
                                />
                            }
                        </div>
                    </div>
                </div>
                <div id='step2' className={defineStepClass(2)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-car'/>
                        </div>
                        <div className='title-text'>{step === 2 && t('Waiting')} {t('Send vehicle image')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 2 &&
                                <UploadCarImage
                                    insuranceType={accident.insurance_type}
                                    attachments={accident.attachments}
                                    losses={accident.losses}
                                    changeStep={changeStep}
                                    uploadDoc={uploadDoc}
                                />
                            }
                        </div>
                    </div>
                </div>
                <div id='step3' className={defineStepClass(3)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-car-crash'/>
                        </div>
                        <div className='title-text'>{step === 3 && t('Waiting')} {t('Sending positions and damaged parts')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 3 &&
                                // <UploadCrashImages
                                //     attachments={accident.attachments}
                                //     changeStep={changeStep}
                                //     uploadDoc={uploadDoc}
                                // />
                                <UploadCrashImage
                                    losses={accident.losses}
                                    attachments={accident.attachments}
                                    changeStep={changeStep}
                                    uploadDoc={uploadDoc}
                                    insuranceType={accident.insurance_type}
                                />
                            }
                        </div>
                    </div>
                </div>
                <div id='step4' className={defineStepClass(4)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-car-crash'/>
                        </div>
                        <div className='title-text'>{step === 4 && t('Waiting')} {t('Send accident image')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 4 &&
                                <UploadDamageImage
                                    attachments={accident.attachments}
                                    changeStep={changeStep}
                                    uploadDoc={uploadDoc}
                                />
                                
                            }
                        </div>
                    </div>
                </div>
                <div id='step5' className={defineStepClass(5)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='far fa-compass'/>
                        </div>
                        <div className='title-text'>{step === 5 && t('Waiting')} {t('Select position in map')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 5 &&
                                <Maps
                                    changeStep={changeStep}
                                    onFinish={finish}
                                />
                            }
                        </div>
                    </div>
                </div>
                <div id='step6' className={defineStepClass(6)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-user'/>
                        </div>
                        <div className='title-text'>{step === 6 && t('Waiting')} {t('Expert assignment')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 6 &&
                                <div className='complete-content text-center'>
                                    <p>{t('Waiting for expert assignment')}</p>
                                    <p>{t('Thanks for your patiance')}</p>
                                    <i className='fas fa-spinner fa-spin mt10'
                                       style={{color: '#30bfc7', fontSize: 30}}/>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div id='step7' className={defineStepClass(7)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-shipping-fast'/>
                        </div>
                        <div className='title-text'>{step === 7 && t('Waiting')} {t('Dispatch Expert')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 7 &&
                                <div className='complete-content text-center'>
                                    <p>{t('Expert info')}:</p>
                                    <div className='mt20'>
                                        <img
                                            src={
                                                expert.avatar ?
                                                    `${url}/files?uid=${expert.avatar.uid}&width=200&height=200` :
                                                    defaultProfile
                                            }
                                            alt='profile'
                                            className='profile-pic'
                                        />
                                    </div>
                                    <p className='mt10'>{expert.fname} {expert.lname}</p>
                                    <Timer seconds={300} onFinish={() => setCallPermit(true)}/>
                                    <div className='expert-button-parent mt10'>
                                        <div className='flex1 text-center pr5'>
                                            <a className='btn btn-green btn-sm btn-block btn-circle'
                                               href={`tel:${expert.mobile}`}>
                                                {t('Contact with expert')}
                                            </a>
                                        </div>
                                        {
                                            callPermit &&
                                            <div className='flex1 text-center pl5'>
                                                <a className='btn btn-red btn-sm btn-block'
                                                   href='tel:02191065151'>{t('Contact with company')}</a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    );

}
